import { render, staticRenderFns } from "./SurveyBuilder.vue?vue&type=template&id=38add370&scoped=true&"
import script from "./SurveyBuilder.vue?vue&type=script&lang=js&"
export * from "./SurveyBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBuilder.vue?vue&type=style&index=0&id=38add370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38add370",
  null
  
)

export default component.exports